export const PRICE_KEYS = [
	'accessibility.prices.currentPrice.variable',
	'accessibility.prices.firstStrikethroughPrice.variable',
	'accessibility.prices.secondStrikethroughPrice.variable',
	'accessibility.prices.thirdStrikethroughPrice.variable',
	'productCard.discountDescription.text',
	'productCard.discountDescription.outlet.text',
	'accessibility.priceInformation.icon',
]

export const OUTLET_PRICES_HISTORY_LABEL_KEYS = [
	'productCard.firstPrice.shop.title',
	'productCard.firstPrice.outlet.title',
	'productCard.omnibusPrice.title',
	'productCard.currentPrice.title',
]

export const SHOP_PRICES_HISTORY_LABEL_KEYS = [
	'productCard.firstPrice.title',
	'productCard.omnibusPrice.title',
	'productCard.currentPrice.title',
]

export const UNIQUE_PRICES_HISTORY_LABEL_KEYS = Array.from(
	new Set([
		...OUTLET_PRICES_HISTORY_LABEL_KEYS,
		...SHOP_PRICES_HISTORY_LABEL_KEYS,
	])
)

export const OMNIBUS_KEYS = [
	'productCard.priceHistory.title',
	...UNIQUE_PRICES_HISTORY_LABEL_KEYS,
]
